import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Es legal tener esta guía?',
  answer: 'Absolutamente. Esta guía contiene información de derechos constitucionales que aplican a todas las personas en Estados Unidos, sin importar su estatus migratorio. Conocer tus derechos es completamente legal y necesario.'
}, {
  question: '¿En qué formato viene?',
  answer: 'La guía viene en formato PDF digital de alta calidad que puedes leer en tu teléfono, tablet o computadora. La recibes en tu correo electrónico inmediatamente después de tu compra.'
}, {
  question: '¿La información está actualizada?',
  answer: 'Sí. Esta edición 2026 incluye los cambios más recientes en políticas migratorias y recursos legales disponibles. Nos aseguramos de mantener el contenido vigente.'
}, {
  question: '¿Puedo compartirla con mi familia?',
  answer: 'Sí, la guía es para uso personal y familiar. Te animamos a que la compartas con tus seres queridos que vivan contigo para que todos estén preparados.'
}, {
  question: '¿Qué pasa si no me sirve?',
  answer: 'Ofrecemos una garantía de devolución de 7 días. Si sientes que la guía no te aporta valor, escríbenos y te devolvemos tu dinero sin preguntas.'
}, {
  question: '¿Necesito un abogado para usar esta guía?',
  answer: 'No. La guía está escrita en lenguaje sencillo para que cualquier persona pueda entenderla y aplicarla. Sin embargo, siempre recomendamos consultar con un abogado para casos específicos y complejos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#0c1222] text-white border-t border-white/10" data-id="element-40">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-42">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 uppercase tracking-wide" data-id="element-43">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto" data-id="element-44" />
        </motion.div>

        <div className="space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`border ${openIndex === index ? 'border-[#c0392b] bg-[#141e33]' : 'border-white/10 bg-transparent'} transition-colors duration-300`} data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex items-center justify-between w-full p-6 text-left focus:outline-none" data-id="element-47">
                <span className={`font-sans font-bold text-lg md:text-xl ${openIndex === index ? 'text-white' : 'text-gray-300'}`} data-id="element-48">
                  {faq.question}
                </span>
                <span className={`ml-4 flex-shrink-0 ${openIndex === index ? 'text-[#c0392b]' : 'text-gray-500'}`} data-id="element-49">
                  {openIndex === index ? <Minus className="w-6 h-6" data-id="element-50" /> : <Plus className="w-6 h-6" data-id="element-51" />}
                </span>
              </button>

              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-53">
                    <div className="p-6 pt-0 text-gray-300 font-sans leading-relaxed border-t border-white/5 mt-2" data-id="element-54">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}